export default __webpack_public_path__ + "static/media/coconut-icon.dda6c146.svg";